module.exports = __webpack_public_path__ + "images/marketing/peeps/likes/hillary_hall.jpg";